import { KnowledgeGraph } from '../components/knowledge-graph/KnowledgeGraph';

export default function DecisionEngine() {
  return <KnowledgeGraph />;
}
